import { render, staticRenderFns } from "./textChat.vue?vue&type=template&id=262540fe&scoped=true&"
import script from "./textChat.vue?vue&type=script&lang=js&"
export * from "./textChat.vue?vue&type=script&lang=js&"
import style0 from "./textChat.vue?vue&type=style&index=0&id=262540fe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262540fe",
  null
  
)

export default component.exports